export default __webpack_public_path__ + "static/media/maintenance.a7c2c676.png";